const publicPath = (path) => `${process.env.PUBLIC_URL || ''}${path}`;

const books = [
  {
    id: 'battleship',
    title: 'Battleship: 320 Puzzles',
    comingSoon: true,
    bookCode: 'battleship',
    coverUrl: publicPath('/images/Battleship.png'),
    shortBlurb:
      'Find the hidden fleet in 320 Battleship puzzles. Use row and column clues to chart every ship and stretch of water.',
    sortOrder: 1.8,
  },
  {
    id: 'number-kingdoms',
    title: 'Number Kingdoms',
    comingSoon: true,
    bookCode: 'number-kingdoms',
    coverUrl: publicPath('/images/Number_Kingdoms.png'),
    shortBlurb:
      '320 puzzles in six kingdoms. Place digits 1–8 while watching clear sight lines, stone barriers, and knight moves.',
    sortOrder: 1.7,
  },
  {
    id: 'tic-tac-toe-logic-puzzles',
    title: 'Tic-Tac-Toe Logic Puzzles!',
    amazonUrl:
      'https://www.amazon.com/Think-Inside-Grid-Tic-Tac-Toe-Puzzles/dp/B0C9S8W7PP',
    bookCode: 'tic-tac-toe-logic-puzzles',
    coverUrl: publicPath('/images/TicTacToe.jpg'),
    shortBlurb:
      'A playful collection of tic-tac-toe logic challenges that rewards deduction, pattern spotting, and careful placement.',
    featured: true,
    sortOrder: 2,
  },
  {
    id: 'kyudoku',
    title: 'Kyudoku',
    amazonUrl: 'https://www.amazon.com/Kyudoku-Elimination-Japheth-J-Light/dp/B0GY44RC62',
    bookCode: 'kyudoku',
    coverUrl: publicPath('/images/Kyudoku.jpg'),
    shortBlurb:
      'A focused set of Kyudoku elimination puzzles built for solvers who enjoy tight logic and steady momentum.',
    featured: true,
    sortOrder: 3,
  },
  {
    id: 'sudoku-variety-pack',
    title: 'Sudoku Variety Pack',
    amazonUrl: 'https://www.amazon.com/Sudoku-Variety-Pack-Japheth-Light/dp/B0GVNLY27W',
    bookCode: 'sudoku-variety-pack',
    coverUrl: publicPath('/images/5-of-5_6x6_Variety_Sudoku.jpg'),
    shortBlurb:
      'A mixed collection of 6x6 Sudoku variants for players who want several different rule twists in one place.',
    featured: true,
    sortOrder: 4,
  },
  {
    id: '6x6-classic-sudoku-variants',
    title: '6x6 Classic Sudoku Variants',
    amazonUrl: 'https://www.amazon.com/6x6-Classic-Sudoku-Variants/dp/B0GVMXM9ZT',
    bookCode: '6x6-classic-sudoku-variants',
    coverUrl: publicPath('/images/1-of-5_6x6_Classic_Sudoku.jpg'),
    shortBlurb:
      'Compact classic Sudoku puzzles with a 6x6 footprint that keeps each solve brisk, clear, and satisfying.',
    sortOrder: 8,
  },
  {
    id: '6x6-jigsaw-sudoku-variants',
    title: '6x6 Jigsaw Sudoku Variants',
    amazonUrl: 'https://www.amazon.com/6x6-Jigsaw-Sudoku-Variants/dp/B0GVNMNP7Z',
    bookCode: '6x6-jigsaw-sudoku-variants',
    coverUrl: publicPath('/images/2-of-5_6x6_Jigsaw_Sudoku.jpg'),
    shortBlurb:
      '6x6 Jigsaw Sudoku puzzles that swap standard boxes for irregular regions and a fresh style of reasoning.',
    sortOrder: 6,
  },
  {
    id: '6x6-killer-sudoku-variants',
    title: '6x6 Killer Sudoku Variants',
    amazonUrl: 'https://www.amazon.com/6x6-Killer-Sudoku-Variants/dp/B0GVN827B3',
    bookCode: '6x6-killer-sudoku-variants',
    coverUrl: publicPath('/images/3-of-5_6x6_Killer_Sudoku.jpg'),
    shortBlurb:
      'A compact Killer Sudoku collection where arithmetic cages and classic Sudoku logic work together on every grid.',
    sortOrder: 5,
  },
  {
    id: '6x6-diagonal-sudoku-variants',
    title: '6x6 Diagonal Sudoku Variants',
    amazonUrl: 'https://www.amazon.com/6x6-Diagonal-Sudoku-Variants/dp/B0GVNL2LDT',
    bookCode: '6x6-diagonal-sudoku-variants',
    coverUrl: publicPath('/images/4-of-5_6x6_Diagonal_Sudoku.jpg'),
    shortBlurb:
      'Diagonal Sudoku puzzles that add two extra lines of logic while keeping the approachable 6x6 board size.',
    sortOrder: 7,
  },
  {
    id: '16x16-mega-sudoku',
    title: '16x16 Mega Sudoku',
    amazonUrl:
      'https://www.amazon.com/16x16-Mega-Sudoku-Puzzles-Sudoku-Enthusiast/dp/B0CFZH174N',
    bookCode: '16x16-mega-sudoku',
    coverUrl: publicPath('/images/16x16_Mega_Sudoku.jpg'),
    shortBlurb:
      'A larger-format Sudoku challenge for experienced players who want longer solves and denser deduction chains.',
    sortOrder: 9,
  },
  {
    id: 'snowflake-sudoku',
    title: 'Snowflake Sudoku',
    amazonUrl:
      'https://www.amazon.com/Snowflake-Sudoku-Snowflakes-Number-Puzzles/dp/B0H1LHL29G',
    bookCode: 'snowflake-sudoku',
    coverUrl: publicPath('/images/Snowflake_Sudoku.jpg'),
    shortBlurb:
      'A geometric Snowflake Sudoku collection built around crisp number-placement logic and a fresh puzzle shape.',
    sortOrder: 1,
  },
  {
    id: 'tridoku-volume-1',
    title: 'Tridoku: Volume 1',
    amazonUrl: 'https://www.amazon.com/gp/product/B0HK3M6B21',
    bookCode: 'tridoku-volume-1',
    coverUrl: publicPath('/images/Tridoku_Volume_1.png'),
    shortBlurb:
      'The first volume in the Tridoku trilogy, with 240 triangular Sudoku puzzles built for steady, satisfying deduction.',
    sortOrder: 1.4,
  },
  {
    id: 'tridoku-volume-2',
    title: 'Tridoku: Volume 2',
    amazonUrl: 'https://www.amazon.com/gp/product/B0HK3FQNJV',
    bookCode: 'tridoku-volume-2',
    coverUrl: publicPath('/images/Tridoku_Volume_2.png'),
    shortBlurb:
      'The second Tridoku volume adds 240 more triangular Sudoku puzzles in a fresh standalone collection.',
    sortOrder: 1.5,
  },
  {
    id: 'tridoku-volume-3',
    title: 'Tridoku: Volume 3',
    amazonUrl: 'https://www.amazon.com/gp/product/B0HK3QV2Q7',
    bookCode: 'tridoku-volume-3',
    coverUrl: publicPath('/images/Tridoku_Volume_3.png'),
    shortBlurb:
      'The third volume rounds out the trilogy with another 240 triangular Sudoku puzzles for dedicated logic solvers.',
    sortOrder: 1.6,
  },
  {
    id: 'snowflake-bunny-slope',
    title: 'Snowflake Sudoku: Bunny Slope',
    amazonUrl: 'https://www.amazon.com/gp/product/B0H7P6QPXT',
    bookCode: 'snowflake-bunny-slope',
    coverUrl: publicPath('/images/Bunny_slope.png'),
    shortBlurb:
      'A beginner-friendly collection of 320 easy puzzles designed for learning Snowflake Sudoku one step at a time.',
    sortOrder: 1.1,
  },
  {
    id: 'snowflake-blue-square',
    title: 'Snowflake Sudoku: Blue Square',
    amazonUrl: 'https://www.amazon.com/gp/product/B0H7NPKMJW',
    bookCode: 'snowflake-blue-square',
    coverUrl: publicPath('/images/Blue_square.png'),
    shortBlurb:
      'An intermediate collection of 320 medium Snowflake Sudoku puzzles for solvers ready for a steeper challenge.',
    sortOrder: 1.2,
  },
  {
    id: 'snowflake-double-black-diamond',
    title: 'Snowflake Sudoku: Double Black Diamond',
    amazonUrl: 'https://www.amazon.com/gp/product/B0H7NRY6M4',
    bookCode: 'snowflake-double-black-diamond',
    coverUrl: publicPath('/images/Black_diamond.png'),
    shortBlurb:
      'An extreme-level collection of 320 Snowflake Sudoku puzzles created for experienced and determined solvers.',
    sortOrder: 1.3,
  },
];

export const bookCatalog = [...books].sort((left, right) => left.sortOrder - right.sortOrder);

export const availableBooks = bookCatalog.filter((book) => Boolean(book.amazonUrl));

export const upcomingBooks = bookCatalog.filter((book) => !book.amazonUrl);

export default bookCatalog;
